import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UtilsService } from 'src/app/utils/utils.service';
import { AppConstants } from '../application.constant';
// import { TranslateService } from '@ngx-translate/core';
import { LandingPageService } from '../landing-page.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isBurgerClicked = false
  showLogin: boolean = false;
  isLoggedIn: boolean = false;
  languages = ['en', 'te', 'hi'];
  lang: any;
  catSelection = "rf";
  ogData = {};
  nData = {};
  @ViewChild("Settings",{static:false}) templateRef: TemplateRef<any>;
  showThresholdSettings= false;
  modal: any;
  isLoggedin = false;
  currentLatLong: any;

  constructor(
    private router: Router,
    private utils:UtilsService,
    private toastr: ToastrService,
    // public translate: TranslateService,
    public landingService:LandingPageService,
    public modalRef: NgbModal,
  ) {
    // translate.addLangs(['en', 'te', 'hi']);
    // translate.setDefaultLang('en');

    // const browserLang = translate.getBrowserLang();
    this.lang = localStorage.getItem("lang");
    this.lang = (this.lang=='en' || this.lang=='te') ? this.lang : 'en';
    // this.utils.setLanguage(browserLang);
    localStorage.setItem("lang", this.lang)
    // translate.use(browserLang.match(/en|te|hi/) ? browserLang : 'en');
  }

  ngOnInit() {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');

    if(localStorage.getItem("ACCESS_TOKEN")){
      this.isLoggedIn = true;
    }

    this.utils.getLoginPrompt().subscribe(logVal=>{
      this.isLoggedin = logVal;
    })
  }

  translation(language) {
    // this.translate.use(language);
    this.lang = language;
    localStorage.setItem("lang", this.lang)
    // this.utils.setLanguage(this.lang);
    console.log("lanfg", this.lang);
  }


  burgerButton(){
    this.isBurgerClicked = !this.isBurgerClicked
  }

  logOut(){
    this.utils.clearLogin();
    this.isLoggedIn = false;
  }

  userButton(){
    this.utils.setShowLoginBox(true);
  }
  getClose(value){
    this.showLogin = value;
  }

  getLogin(value){
    this.isLoggedIn = value;
    console.log('isLoggedIn',value)
  }

  getWebEocThresholds(){
    this.landingService.getWebEocThresholds().subscribe(data=>{
      console.log("thisone",data)
      this.ogData = data;
      this.nData = data
      this.showThresholdSettings = true;
    })
  }

  cogClick(){
    this.getWebEocThresholds();
    this.modal = this.modalRef.open(this.templateRef,{
      // size: 'lg',
      backdrop: true,
      centered: true,
      keyboard:true,
      windowClass: ''
    });
    this.modal.result.then(()=>{
      this.showThresholdSettings = false;
      console.log("closed");
    },()=>{
      this.showThresholdSettings = false;
      console.log("backClicked");
    })
  }

  validate(str:string, event:any){
    console.log(event);
    if (isNullOrUndefined(event)) {
      console.log("cannot be null");
      this.nData[str] = this.ogData[str];
    }
  }

  navigate(component: string) {
    if(Object.keys(AppConstants.APP_ROUTES).includes(component)){
      this.router.navigate([AppConstants.APP_ROUTES[component]]);
    }else{
      this.router.navigateByUrl(component)
    }
  }

  reset(){
    this.showThresholdSettings = false;
    this.getWebEocThresholds();
  }

  update(){
    let sendRequest = true;
    Object.values(this.nData).forEach(vals=>{
      if(isNullOrUndefined(vals)){
        sendRequest = false;
      }
    })
    if(sendRequest){
      let postData = {}
      Object.keys(this.nData).forEach(key=>{
        postData[key] = (this.nData[key]).toString();
      })
      this.landingService.setWebEocThresholds(postData).subscribe(respose=>{
        if(respose.length==0){
          this.toastr.success('Thresholds Successfully updated', '', {closeButton: true});
          this.modalRef.dismissAll();
        }
      })
    }else{
      this.toastr.warning('Values cannot be empty', '', {closeButton: true});
    }
  }

  closeAllModals(){
    this.modalRef.dismissAll();
  }

  userClick(){
    this.router.navigate(['createuser']);
    console.log('user clicked')
  }

  gotoWebeocPortal(){
    this.router.navigate(['webeocportal']);

  }
  gotostateReport(){
    this.router.navigate(['statereport']);

  }
  goHome(){
    console.log(this.utils.getDeviceType())
    this.currentLatLong = this.utils.getCurrentLatLongFromLS();
    console.log(this.currentLatLong )
    if(this.utils.getDeviceType() == 'mobile')
      this.router.navigate(['/mobile',this.currentLatLong])
    else
      this.router.navigate(['/heatwatches/heatwave/akbm'])
  }

  logOutForDims(){
    this.router.navigate(['/'])
  }
}
